import { Injectable } from '@angular/core'
import { MatDialogConfig } from '@angular/material/dialog'
import { BdcCreatePropertyDialogComponent } from './bdc-create-property-dialog.component'
import { Channel, DialogService } from '@tokeet-frontend/tv3-platform'

@Injectable()
export class BdcCreatePropertyDialogService {
  constructor(private dialog: DialogService) {}

  open(channel: Channel) {
    const defaultConfig: MatDialogConfig = {
      width: '700px',
      height: 'auto',
      data: { channel },
    }

    return this.dialog.openVariableDialog(BdcCreatePropertyDialogComponent, defaultConfig)
  }
}
